import React from 'react';
import {Box, VStack, Text, useTheme} from '@chakra-ui/react';
import MeetUpCard from '../../components/Articles/MeetUpCard';
import {Event} from '../../types/article';
import {TextG18, TextG32} from '../../components/typography';
import DefaultEventImage from '../../assets/images/default_event.png';

// Ambassador topic ID - when this topic is present, show the "Meet a Community Connector" badge
const AMBASSADOR_PRESENT_TOPIC = process.env.NODE_ENV === 'production' ? 336 : 223;

// Mock event data for the MeetUpCard
const mockEvent = {
  id: 1,
  title: 'Open Mic Comedy with i.Bar.Laughs',
  start_date: new Date().toISOString(),
  start_time: '19:00:00',
  location_name: 'CinKuni (Italian & Japan...',
  distance: 3.8,
  attendees_count: 15,
  is_meetup: true,
  place: {
    id: 1,
    name: 'CinKuni (Italian & Japan...)',
    latitude: 32.7157,
    longitude: -117.1611,
    image_url: DefaultEventImage,
  } as any,
  user: {
    id: 1,
    first_name: 'Community',
    last_name: 'Connector',
  } as any,
  rsvp_status: null,
  topics_of_interest: [
    {
      id: AMBASSADOR_PRESENT_TOPIC,
      name: 'Ambassador Present',
    } as any,
  ],
} as unknown as Event;

const IntroCallToAction = () => {
  const theme = useTheme();

  return (
    <VStack
      flex={1}
      spacing={8}
      px={4}
      pt={8}
      pb={4}
      align="center"
      justify="flex-start"
      overflow="auto">
      {/* Title */}
      <Box textAlign="center" maxW="350px" mb={8}>
        <TextG32 fontSize="32px" fontWeight="700" lineHeight="44px" mb={0} color={'#262626'}>
          Meet{' '}
          <TextG32 as="span" color="#C9136B">
            Community Connectors
          </TextG32>
        </TextG32>
      </Box>

      {/* Card Section */}
      <Box w="100%" maxW="400px" position="relative" my={'3rem !important'}>
        {/* MeetUpCard */}
        <Box pointerEvents="none">
          <MeetUpCard meet-up={mockEvent} />
        </Box>
      </Box>

      {/* Description */}
      <Box textAlign="center" maxW="350px" px={4}>
        <TextG18 color={'#262626'} fontWeight="500" lineHeight="28px">
          Join events with Community Connectors, who help new members feel welcome and included from
          the start.
        </TextG18>
      </Box>
    </VStack>
  );
};

export default IntroCallToAction;
